"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castiglione-di-garfagnana": {
    "dc10d8c1": [{
      "hkey": "b7a1f9cb",
      "slug": "campori-marcione",
      "name": "Campori-Marcione",
      "primary": true,
      "skipSearch": false
    }],
    "campori": [{
      "hkey": "b7a1f9cb",
      "slug": "campori-marcione",
      "name": "Campori-Marcione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7ce761bc": [{
      "hkey": "d2d90ca1",
      "slug": "castiglione-di-garfagnana",
      "name": "Castiglione di Garfagnana",
      "primary": true,
      "skipSearch": false
    }],
    "passo-delle-radici": [{
      "hkey": "d2d90ca1",
      "slug": "castiglione-di-garfagnana",
      "name": "Castiglione di Garfagnana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "73686907": [{
      "hkey": "79c9eb31",
      "slug": "san-pellegrino-in-alpe",
      "name": "San Pellegrino in Alpe",
      "primary": true,
      "skipSearch": false
    }],
    "san-pellegrino": [{
      "hkey": "79c9eb31",
      "slug": "san-pellegrino-in-alpe",
      "name": "San Pellegrino in Alpe",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;